const MyDeliverySaverPaymentsComponentDefinition = {
    bindings: {
        payments: '<',
    },
    template: require('./my-delivery-saver-payments.component.html').trim(),
};

module.exports = {
    MyDeliverySaverPaymentsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/mydeliverysaver/payments/my-delivery-saver-payments.component.js